import React from 'react'
import classNames from 'classnames'

interface Props {
  className?: string
  children: React.ReactNode
}

export const EloModalFooter: React.FC<Props> = ({ children, className }) => (
  <div className={classNames('elo-ui-modal__footer', className)}>{children}</div>
)
